import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const jurisdictionAreaTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Jurisdiction Area',
  key: 'CF_GROUP', // @sumedh will change once find the usage
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['SS8ID', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      SS8ID: {
        label: 'Area Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Max 16 characters with no spaces',
            },
          ],
        },
      },
    },
  },
};
